import { dispatch } from "../store/store";
import {
  getPharmacyDashboardData,
  setIsPharmacyDashboardLoading,
  getScheduleEventsByUserData,
  getActiveConsultationsByUserData,
  getPharmacyNotificationsData,
  markNotificationsAsReadData,
  markNotificationAsReadData,
} from "../features/pharmacyDashboardSlice/pharmacyDashboardSlice";
import { logErrorWithPayload } from "../services/logService";

export const setPharmacyDashboardLoading = (isLoading) => {
  dispatch(setIsPharmacyDashboardLoading(isLoading));
};

export const getPharmacyDashboard = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPharmacyDashboardData({ data })).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const getScheduleEventsByUser = async (pharmacyID, userEmails) => {
  let result = null;
  const validUserEmails = Array.isArray(userEmails)
    ? userEmails.filter((email) => typeof email === "string" && email.trim())
    : [];
  if (!pharmacyID || validUserEmails.length === 0) {
    return result;
  }
  try {
    result = await dispatch(
      getScheduleEventsByUserData({ pharmacyID, userEmails: validUserEmails }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const getActiveConsultationsByUser = async (pharmacyID, userEmails) => {
  let result = null;
  const validUserEmails = Array.isArray(userEmails)
    ? userEmails.filter((email) => typeof email === "string" && email.trim())
    : [];
  if (!pharmacyID || validUserEmails.length === 0) {
    return result;
  }
  try {
    result = await dispatch(
      getActiveConsultationsByUserData({
        pharmacyID,
        userEmails: validUserEmails,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getPharmacyNotifications = async (pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(getPharmacyNotificationsData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const markNotificationsAsRead = async (pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(markNotificationsAsReadData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const markNotificationAsRead = async (notificationId) => {
  let result = null;
  try {
    result = await dispatch(
      markNotificationAsReadData(notificationId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
